import React, { useState, useEffect } from 'react';
import useFetch from '../services/useFetch';
import { TextField, Button, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ManualEntry from '../components/Inventory/ManualEntry';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid, GridToolbarContainer, GridToolbarFilterButton, GridToolbarExport } from "@mui/x-data-grid"
import { Dialog, DialogContent } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import InvoiceDetails from '../components/InvoiceHistory/InvoiceDetails';
import UploadedNewIngredient from '../components/Menu/HelperDialogs/UploadedNewIngredient';
import SnackbarEx from '../components/Helpers/SnackbarEx';
import FulfillInvoice from '../components/InvoiceHistory/FulfillInvoice';
import InformNewItemRecipe from '../components/Menu/posMenuTab/posMenuSubComponents/InformNewItemRecipe.jsx';
import ProductCsv from '../components/Inventory/UploadNewItems/ProductCsv.jsx'
import AddPDFFile from '../components/Inventory/HandleUploadInvoice/AddPDFFile.jsx'
import InvoiceButton from '../components/Inventory/InvoiceButton.jsx';
import AddIngredient from '../components/Inventory/AddIngredient.jsx';
import useApiData from '../services/useApiData.js'
import PageHeader from '../components/layout/PageHeader.jsx';
import { dataGridSx } from '../components/ui/dataGridStyles.js';

const apiUrl = "api/invoice"
export default function InvoiceHistory({ reload }) {

    const [reloadData, setReloadData] = useState(reload)
    const [expandViewIn, setExpandViewIn] = useState(null)
    const [expandView, setExpandView] = useState(false)
    const [openRepeatInvoice, setOpenRepeatInvoice] = useState(false)
    const [invNum, setInvNum] = useState(null)
    const [invVendId, setInvVendId] = useState(null)
    const [openNewIngredientInfo, setOpenNewIngredientInfo] = useState(false)
    const navigate = useNavigate()
    const [openRecipeInform, setOpenRecipeInform] = useState(false)
    const [newIngredients, setNewIngredients] = useState(null)
    const [editUploadedPDF, setEditUploadedPDF] = useState(false)

    const [row, setRow] = useState([])
    const [col, setCol] = useState([])
    const [unfulfilledInvVendor, setUnfulfilledInvVendor] = useState({
        "vendor": null,
        "vendorId": null,
        "invoiceNumber": null,
        "orderNumber": null
    })
    const [addManInvoice, setAddManInvoice] = useState(false)
    const [autoAddInvoice, setAutoAddInvoice] = useState(null)
    const [addIngredient, setAddingredient] = useState(false)
    const [openProdUpl, setOpenProdUpl] = useState(false)
    const [openFulfillment, setOpenFulfillment] = useState(false)

    const [openTestSnack, setOpenTestSnack] = useState({
        color: "",
        message: "",
        open: false
    })

    // const { data, error, load } = useFetch(apiUrl, reloadData)
    const { data, error: invoiceError, isLoading: load, refetch: refetchInvoice } = useApiData(apiUrl)
    console.log(data)
    useEffect(() => {
        if (data !== null) {
            setData()
        }
    }, [data])

    const setData = () => {
        setRow((data || []).map((e) =>
        ({
            id: e._id,
            fulfilled: e.fulfilled,
            invoiceNumber: e.invoiceNum,
            vendor: e.vendor,
            date: e.date,
            totalCost: e.totalPrice
        })
        ))

        setCol([
            {
                field: 'fulfilled', headerName: 'isReceived?', maxWidth: 135, minWidth: 135, renderCell: (params) => {
                    const rowEl = data.find(elem => elem["_id"] === params.id)
                    if (rowEl.fulfilled) {
                        return (<p style={{ padding: '15px 0px', margin: '0', fontSize: 'small', fontWeight: "600" }}>
                            Received
                        </p>)
                    } else {
                        return (
                            <button
                                style={{
                                    height: '30px', paddingLeft: '0', background: 'rgba(0, 163, 224, 0.18)', border: "none", color: '#003366', borderRadius: '5px', borderWidth: "1px", width: '215px', fontWeight: '600'
                                }
                                }>
                                Fullfill Invoice
                            </button >
                        )
                    }
                }
            },
            { field: 'invoiceNumber', headerName: 'Invoice Number', flex: .8 },
            { field: 'vendor', headerName: 'Vendor Name', flex: .75 },
            {
                field: 'date', headerName: 'Date of Invoice', flex: .5, type: 'date',
                valueFormatter: (params) => {
                    const date = new Date(params.value);
                    const estOffset = 4 * 60 * 60 * 1000;
                    const estDate = new Date(date.getTime() + estOffset);
                    return estDate.toLocaleDateString('en-US', {
                        month: '2-digit',
                        day: '2-digit',
                        year: 'numeric',
                    });
                },
            },
            {
                field: 'totalCost', headerName: 'Invoice Total Cost', flex: .5, valueFormatter: ({ value }) =>
                    value ? `$ ${value.toFixed(2)}` : '$ ' + 0.0
            },
            {
                field: 'expand', headerName: '', maxWidth: 37, minWidth: 37,
                renderCell: (params) => (
                    <div>
                        {expandViewIn === params.row.col1 ? (
                            <KeyboardArrowDownIcon fontSize='small' sx={{ paddingBottom: '3px' }} />
                        ) : (
                            <KeyboardArrowRightIcon fontSize='small' sx={{ paddingBottom: '3px' }} />
                        )}
                    </div>
                ),
            }
        ])
    }

    const expandInvoice = async (param) => {

        const index = param.id
        try {
            const invNumVal = await data.find((item) => item._id === index)
            if (param.field !== "fulfilled") {

                setInvNum(invNumVal._id)
                setInvVendId(invNumVal.vendorId)

                setExpandViewIn(index === expandViewIn ? null : index)
                setExpandView(!expandView)
            } else {
                setUnfulfilledInvVendor(prev => ({
                    ...prev,
                    ["vendor"]: invNumVal.vendor,
                    ["vendorId"]: invNumVal.vendorId,
                    ["orderNumber"]: invNumVal.invoiceNum
                }))
                setOpenFulfillment(true)
            }
        } catch (err) { console.log(err) }
    }

    const handlePopupClose = async (close, invNumArg, invVendorArg, editUpload) => {
        setExpandView(false)
        refetchInvoice()
        if (close === 'close' || close === 'exitIcon') {
            setExpandView(false)
            setOpenRepeatInvoice(false)
            setOpenFulfillment(false)
            setEditUploadedPDF(false)
        } else if (close === "openInvoice") {
            setExpandView(false)
            // Re-invoice / edit can pass ids as args, or an object for edit path
            if (invNumArg && typeof invNumArg === 'object' && invNumArg.invNum != null) {
                setInvNum(invNumArg.invNum)
                setInvVendId(invNumArg.invVend)
            } else {
                if (invNumArg != null) setInvNum(invNumArg)
                if (invVendorArg != null) setInvVendId(invVendorArg)
            }
            setOpenRepeatInvoice(true)
            // editUpload true = update existing invoice; false/undefined = re-invoice (new)
            setEditUploadedPDF(Boolean(editUpload))
        } else if (close === "success") {
            setExpandView(false)
            setOpenFulfillment(false)
            setOpenRepeatInvoice(false)
            setEditUploadedPDF(false)

            refetchInvoice()
            setOpenTestSnack({ color: "success", message: "Successfully added invoice!", open: true })
        } else if (close === "parDetails") {
            setOpenNewIngredientInfo(false)
            setOpenTestSnack({ color: "success", message: "Ingredient updated!", open: true })
            refetchInvoice()
            if (invNum === "NEWING") {
                /// Popup to tell the user to add ing to a recipe in menu
                setOpenRecipeInform(true)
            }
        } else if (close === "confirm-new-item") {
            setOpenRecipeInform(false)
            navigate("/menu")
        }
    }

    const handleNewIngredients = (newItems) => {
        setOpenNewIngredientInfo(true)
        setNewIngredients(newItems);
    }

    const refreshPage = () => {
        setReloadData(true)
        setTimeout(() => {
            // Code to be executed after the delay
            setReloadData(false)
        }, 200);
    }

    const invoiceAddType = (type) => {
        console.log(type)
        if (type === "Manually Add Invoice") setAddManInvoice(true)
        else if (type === "Upload PDF/Image") setAutoAddInvoice(true)
        else if (type === "Add Raw Material") setAddingredient(true)
        else if (type === "Upload New Items") setOpenProdUpl(true)
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <div className="me-auto d-flex align-items-center" style={{ gap: 10 }}>
                    <InvoiceButton selection={invoiceAddType} />
                </div>
                <GridToolbarFilterButton />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }

    const closeDialog = async (val, reason) => {
        console.log(val, reason)
        if (val === 'success') {
            setAddManInvoice(false)
            setAutoAddInvoice(false)
            setAddingredient(false)
            setOpenProdUpl(false)
            setOpenTestSnack({ color: 'success', message: reason ? `${reason} added successfully!` : 'Successfully added!', open: true })
            refetchInvoice()
            return
        }
        if (val === 'pdfUpload') {
            setAutoAddInvoice(false)
            if (reason) {
                const unknowns = reason.unknowns || reason
                setInvNum(unknowns.invoiceNum || unknowns.invNum || invNum)
                setInvVendId(unknowns.vendorId || unknowns.invVend || invVendId)
                setExpandView(true)
            } else {
                setOpenTestSnack({
                    color: 'info',
                    message: 'Processing… please allow time for automatic PDF processing.',
                    open: true,
                })
            }
            refetchInvoice()
            return
        }
        if (val === 'ingredient failure') {
            setAddingredient(false)
            setOpenTestSnack({
                color: 'error',
                message: reason || 'Error occurred. Please try again.',
                open: true,
            })
            return
        }
        if (val === 'exitIcon' || val === 'closeUpload' || reason === 'backdropClick') {
            setAddManInvoice(false)
            setAutoAddInvoice(false)
            setAddingredient(false)
            setOpenProdUpl(false)
            return
        }
        setAddManInvoice(false)
        setAutoAddInvoice(false)
        setAddingredient(false)
        setOpenProdUpl(false)
        refetchInvoice()
    }

    const handleNewUploadIngredients = (newItems) => {
        console.log(newItems)
    }


    const CustomNoRowsOverlay = () => (
        <div style={{ padding: '20px', textAlign: 'center', justifyContent: 'center', display: 'flex', height: '100%', alignItems: 'center' }}>
            No invoices to display.
        </div>
    );
    return (
        <>
            <PageHeader
                title="Invoices"
                subtitle="Select an invoice to review details and fulfillment"
            />
            <div style={{ padding: '8px 12px 24px' }}>
                    <DataGrid
                        rows={row}
                        loading={load}
                        columns={col}
                        rowHeight={40}
                        // pageSizeOptions={[25]}
                        // onRowClick={(param) => expandInvoice(param)}
                        onCellClick={expandInvoice}
                        slots={{
                            toolbar: CustomToolbar,
                            noRowsOverlay: CustomNoRowsOverlay, // Add this line
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 50,
                                },
                            },
                        }}

                        sx={{
                            ...dataGridSx,
                            border: 'none',
                        }}
                    />
                <div >
                    <Dialog
                        maxWidth="md"
                        fullWidth
                        open={expandView}
                        onClose={handlePopupClose}
                        id="pop-up"
                        PaperProps={{
                            sx: {
                                borderRadius: 2,
                                overflow: 'hidden',
                                minHeight: 420,
                                display: 'flex',
                                flexDirection: 'column',
                            },
                        }}
                    >
                        <DialogContent
                            sx={{
                                p: '0 !important',
                                pt: '0 !important',
                                overflow: 'visible',
                                minHeight: 360,
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <InvoiceDetails invnum={invNum} invVendor={invVendId} close={handlePopupClose} />
                        </DialogContent>
                    </Dialog >

                    <Dialog maxWidth={'sm'} open={openRecipeInform} onClose={handlePopupClose} >
                        <InformNewItemRecipe close={handlePopupClose} />
                    </Dialog>
                    <Dialog fullScreen open={openRepeatInvoice} onClose={handlePopupClose} >
                        <ManualEntry close={handlePopupClose} invoiceOrigin={invNum} invoiceOriginVendor={invVendId} uploadEdit={editUploadedPDF} />
                    </Dialog>

                    <Dialog maxWidth={"sm"} fullWidth sx={{ '&.MuiPaper-root': { maxWidth: "500px" } }} open={openFulfillment} onClose={handlePopupClose} >
                        <FulfillInvoice invoiceInfo={unfulfilledInvVendor} close={handlePopupClose} newIngredients={handleNewIngredients} />
                    </Dialog>

                    <Dialog maxWidth={'sm'} fullWidth open={openNewIngredientInfo} onClose={handlePopupClose} >
                        <UploadedNewIngredient close={handlePopupClose} ingredients={newIngredients} />
                    </Dialog>
                </div>
                {
                    openTestSnack.open && <SnackbarEx color={openTestSnack.color} message={openTestSnack.message} open={openTestSnack.open}
                        close={() => setOpenTestSnack({
                            color: "",
                            message: "",
                            open: false
                        })} />
                }
            </div>

            {/* This is the dialog for the manual invoice full screen popup */}
            <Dialog fullScreen open={addManInvoice} onClose={closeDialog} >
                <ManualEntry close={closeDialog} newIngredients={handleNewIngredients} />
            </Dialog>
            {/* ----- Upload CSV for Item Add ---- */}
            <Dialog maxWidth={'sm'} open={openProdUpl} onClose={() => setOpenProdUpl(false)} >
                <ProductCsv close={closeDialog} />
            </Dialog>

            <Dialog open={autoAddInvoice} onClose={closeDialog} >
                <AddPDFFile close={closeDialog} newIngredients={handleNewUploadIngredients} />
            </Dialog>

            <Dialog open={addIngredient} onClose={closeDialog}>
                <DialogContent sx={{ borderRadius: '20px' }}>
                    <AddIngredient close={closeDialog} />
                </DialogContent>
            </Dialog>
        </>
    );
};
